<template>
  <div style="height: 20vh; position: relative">
    <div class="icon-spinner" />
  </div>
</template>

<style lang="scss">
@use "@moonlight/styles/scss/tools/spinner" as spinner;

.icon-spinner {
  @include spinner.spinner(2rem, #ffffff);
}
</style>
